<template>
  <div class="animated fadeIn">
    <div class="title font-300 font-24 mb-15">
      {{this.$route.name}}
    </div>
    <div class="box">
      <div class="p-15 pb-0">
        <div class="row">
          <div class="col-sm-5 offset-md-7 text-right">
            <div class="search-header">
              <div class="custom-search-container">
                <div class="input-group custom-search">
                  <input type="text" @keyup.enter="enterClicked(searchData)" v-model="searchData" class="form-control" placeholder="Search">
                  <span class="icon-magnifier icon-input-custom"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr class="mb-0">
      <div class="p-15 pt-0">
        <b-table @sort-changed="sortingChanged" :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" :responsive="true" :items="items" :fields="fields" :current-page="currentPage">
          <template v-slot:cell(branch)="data">
<!--          <template slot="branch" slot-scope="data">-->
            <span>{{ (data.item.branch) ? data.item.branch.name : '-' }}</span>
          </template>
          <template v-slot:cell(action)="data">
<!--          <template slot="action" slot-scope="data">-->
            <template v-if="getRoleId == '1' || user_id == 1 || user_id == 1071808 || user_id == 1071860 || getRoleId == '27' || getRoleId == 27">
              <b-btn @click="openPage('/memberEntry/edit?id=' + data.item.id + '&page=' + currentPage)" size="sm" class="btn-table green"><i class="fas fa-pen mr-5"></i>Edit Detail</b-btn>
              <b-btn v-if="getRoleId == '1' || getRoleId == '6' || getRoleMappingId(6) || user_id == 1071808 || user_id == 1071841" @click="deleteMember(data.item.id)" size="sm" class="btn-table danger"><i class="fas fa-times"></i> Delete</b-btn>
            </template>

            <template v-if="user_id == 1071806 || user_id == 1071879 || user_id == 1071867 || user_id == 511 || user_id == 15102000 || user_id == 1071833 || user_id == 1071836 || getRoleId == '33' ">
              <b-btn @click="openPage('/memberEntry/edit?id=' + data.item.id + '&page=' + currentPage)" size="sm" class="btn-table green"><i class="fas fa-pen mr-5"></i>Edit Detail</b-btn>
            </template>

            <template v-if="getRoleId == '6' || getRoleMappingId(6) || getRoleMappingId(19)">
              <b-btn @click="openPage('/memberEntry/edit?id=' + data.item.id + '&page=' + currentPage)" size="sm" class="btn-table green"><i class="fas fa-pen mr-5"></i>Edit Detail</b-btn>
              <b-btn @click="deleteMember(data.item.id)" size="sm" class="btn-table danger"><i class="fas fa-times"></i> Delete</b-btn>
            </template>

            <template v-if="user_id == 1071844">
              <b-btn @click="deleteMember(data.item.id)" size="sm" class="btn-table danger"><i class="fas fa-times"></i> Delete</b-btn>
            </template>
          </template>

           <template v-slot:cell(is_agree)="data">
            <template>
              <b-badge v-if="data.item.is_agree == 1" :variant="'success'" >Success</b-badge>
              <b-badge v-if="data.item.is_agree == 0"  :variant="'warning'" >Waiting...</b-badge>
            </template>
          </template>
          <template v-slot:cell(is_facerecognition)="data">
            <template>
              <b-badge v-if="data.item.is_facerecognition == 1" :variant="'success'" >Yes</b-badge>
              <b-badge v-if="data.item.is_facerecognition == 0"  :variant="'info'" >No</b-badge>
            </template>
          </template>
          <template v-slot:cell(membership_status_data)="data">
<!--          <template slot="membership_status_data" slot-scope="data">-->
            <template v-if="data.item.membership_status === null">
              <b-badge variant="danger">Non Member</b-badge>
            </template>
            <template v-else>
              <b-badge variant="success">{{data.item.membership_status.name}}</b-badge>
            </template>
          </template>
          <template v-slot:cell(name)="data">
<!--          <template slot="name" slot-scope="data">-->
            {{data.item.first_name}} {{data.item.last_name}}
          </template>
          <template v-slot:cell(id)="data">
<!--          <template slot="id" slot-scope="data">-->
            <template v-if="data.item.branch">
              {{data.item.branch.codename}} -
            </template>
            <template v-else>
              FT -
            </template>
            {{data.item.id}}
          </template>
        </b-table>
        <app-pagination class="pagination-custom mt-20" :current-page="currentPage"
            :total-pages="totalPage"
            @page-changed="pageOneChanged"
            prev-text="Prev" next-text="Next"/>
      </div>
    </div>

    <div v-if="loadingActive == true" class="loading-container">
      <div class="wrap-screen w-100 h-100">
        <img :src="`/svg-loaders/oval.svg`" width="60" alt="">
        <div class="title-loading color-white">Loading...</div>
      </div>
    </div>

  </div>
</template>

<script>
import { Callout } from '@coreui/vue'
import axios from 'axios'
import { Auth } from '@/api'
import Pagination from '@/views/component/pagination'

export default {
  name: 'member',
  components: {
    'app-pagination': Pagination
  },
  props: {
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      loadingActive: false,
      fields: [
        {
          key: 'id',
          label: 'Member ID',
          sortable: true
        },
        {
          key: 'name',
          label: 'Name',
          sortable: true
        },
        {
          key: 'phone_number',
          label: 'Phone Number',
          sortable: true
        },
        {
          key: 'email',
          label: 'Email',
          sortable: true
        },
        {
          key: 'id_card',
          label: 'ID Card',
          sortable: true
        },
        {
          key: 'address',
          label: 'Address',
          sortable: true
        },
        {
          key: 'branch',
          label: 'Branch',
          sortable: true
        },
        {
          key: 'rfid_card_code',
          label: 'No Wristband',
          sortable: true
        },
        {
          key: 'is_agree',
          label: 'Agreement',
          sortable: true
        },
        {
          key: 'pending_remarks',
          label: 'Pending Remarks',
          sortable: true
        },
        {
          key: 'membership_status_data',
          label: 'Membership',
          sortable: true
        },
        {
          key: 'referral_pt',
          label: 'Referral PT',
          sortable: false,
          formatter: (value, key, item) => {
            return item.referral_pt ? item.referral_pt.name  : '-'
          }
        },
        {
          key: 'is_facerecognition',
          label: 'FaceReq',
          sortable: true
        },
        {
          key: 'point_expired_date',
          label: 'Point Expired',
          sortable: false
        },
        {
          key: 'total_point',
          label: 'Total Point',
          sortable: false,
          formatter: (value) => {
            return value ? parseInt(value).toLocaleString('id-ID', {maximumFractionDigits:2}) : 0
          }
        },
        {
          key: 'outstanding.membership_status',
          label: 'Membership Status',
          sortable: false
        },
        {
          key: 'outstanding.qty_month',
          label: 'Payment Status',
          sortable: false
        },
        {
          key: 'outstanding.Months',
          label: 'Outstanding Month',
          sortable: false
        },
        {
          key: 'action',
          label: 'Action',
          sortable: false
        }
      ],
      items: [],
      sortType: '',
      sortBy: '',
      searchData: '',
      currentPage: 1,
      user_id: Auth.Session.get().paradigm_id,
      getRoleId: Auth.Session.get().paradigm_role,
      paginationLimit: 10,
      totalPage: 0
    }
  },
  computed: {
    name () {
      return this.$route.name
    }
  },
  methods: {
    getRoleMappingId(roleId) {
      const roleMapping = Auth.Session.get().paradigm_role_mapping_id.includes(roleId)
      return roleMapping
    },
    pageOneChanged (pageNum) {
      let currentUrl = window.location.href
      let url = new URL(currentUrl)
      url.searchParams.set("page", pageNum)
      let newUrl = url.href
      window.history.pushState("Page","Paradigm Fitness Indonesia","?page="+pageNum)
      this.currentPage = pageNum
      this.fetchData()
    },
    deleteMember (id) {
      this.$swal({
        title: 'Are you sure?',
        text: 'You can\'t revert your action',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes Delete it!',
        cancelButtonText: 'No, Keep it!',
        showCloseButton: true,
        showLoaderOnConfirm: false
      }).then((result) => {
        if(result.value) {
          this.$swal('Deleted', 'You successfully deleted this file', 'success')
          axios.delete('fitness/v1/member/hide/' + id).then(response => {
            this.fetchData()
          }).catch(error => {
            console.log('error', error)
          })
        } else {
          this.$swal('Cancelled', 'Your file is still intact', 'info')
        }
      })
    },
    sortingChanged (event) {
      this.sortBy = event.sortBy
      if (event.sortDesc === false) {
        this.sortType = 'asc'
      } else {
        this.sortType = 'desc'
      }
      this.fetchData()
    },
    enterClicked (searchEvent) {
      this.fetchData()
    },
    getBadge (status) {
      return status === 'Active' ? 'success'
        : status === 'Inactive' ? 'danger'
          : status === 'active' ? 'success'
            : status === 'inactive' ? 'danger' : 'primary'
    },
    parseImg (value) {
      return Auth.apiUrl + 'fitness/v1/img/member/' + value
    },
    getRowCount (items) {
      return items.length
    },
    openPage (event) {
      this.$router.push(event)
    },
    editBlogCategory (event) {
      this.$router.push(event)
    },
    showModal (id) {
      this.$refs[id].show()
    },
    fetchData() {
      this.loadingActive = true
      console.log("user_id : ",this.user_id)
      console.log("getRoleId : ",this.getRoleId)
      axios.get('fitness/v1/member/data_entry?page=' + this.currentPage + '&limit=' + this.paginationLimit + '&sorting=' + this.sortBy + '&sorting_type=' + this.sortType + '&keyword=' + this.searchData + '&v=' + Date.now()).then(response => {
        this.loadingActive = false
        this.items = response.data.data.rows
        this.totalPage = response.data.meta.pageCount
      }).catch(error => {
        this.loadingActive = false
        console.log('error', error)
      })
    }
  },
  mounted () {
    let urlParams = new URLSearchParams(window.location.search)
    let pageParams = urlParams.get('page')
    this.currentPage = (pageParams != null) ? parseInt(pageParams) : 1
    this.fetchData()
  }
}
</script>

<style>
</style>
